import { compose } from "redux";
import classNames from "classnames";
import React, { PureComponent } from "react";
import { Typography, withStyles } from "@material-ui/core";

import { ISO_WEEK_MONDAY } from "app/components/CalendarYear/CalendarDay";

class CalendarWeekNumber extends PureComponent {
  render() {
    const { date, classes, color } = this.props;

    return (
      date.isoWeekday() === ISO_WEEK_MONDAY && (
        <Typography
          color={color}
          className={classNames("CalendarWeekNumber", classes.root)}
        >
          {date.isoWeek()}
        </Typography>
      )
    );
  }
}

const styles = theme => ({
  root: {
    fontSize: "0.5rem",
    lineHeight: "0.5rem",
    position: "absolute",
    top: theme.spacing(0.25),
    left: theme.spacing(0.25),
    zIndex: theme.zIndex.calendarWeek,
    fontWeight: theme.typography.fontWeightBold,
  },
});

export default compose(withStyles(styles))(CalendarWeekNumber);
